import {Component, OnInit, ViewChild, OnDestroy} from '@angular/core';
import {TableReactiveUrlController} from '@amlCore/tableReactive';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {AlertPanelComponent} from '@amlCore/components';
import {NelegalSubject} from '../../model';
import {AccessJson} from '@amlCore/models';
import {CheckDictEnum, RegistriesAccessEnum} from '@amlCore/enums';
import {Utils} from '@amlCore/utils';
import {
  ResourceService,
  TableService,
  UserService,
  VisitedService
} from '@amlCore/services';
import {RegistriesService} from "../../service";


@Component({
  selector: 'app-registry-nelegal-info',
  templateUrl: './nelegalInfo.component.html'
})
export class NelegalInfoComponent extends TableReactiveUrlController implements OnInit, OnDestroy {

  isShowVisited = true;
  loadCheckList = {};
  isSearch = false;
  placeholder = 'Поиск по наименованию, ИНН';
  @ViewChild('alertObjCheck', {static: false}) alertObjToCheck: AlertPanelComponent;

  constructor(private regSrv: RegistriesService,
              private resourceSrv: ResourceService,
              private userSrv: UserService,
              protected activatedRoute: ActivatedRoute,
              protected visitedService: VisitedService,
              protected tableService: TableService,
              protected router: Router) {
    super(router, activatedRoute, visitedService, tableService, {pageSize: 20, sort: 'name', dir: 'ASC'});
  }

  public entries: Array<NelegalSubject> = [];
  public importDate: String;
  access: AccessJson;
  public goBack = Utils.goBack;

  ngOnInit() {
    this.access = this.userSrv.getAccess(RegistriesAccessEnum.QREF_NELEGAL);
    localStorage.removeItem('nelegalSearch');
    this.isSearch = this.router.url.includes('nelegalInfoAll');
    this.activatedRoute.queryParams.subscribe(data => {
      this.resourceSrv.getNelegalInfo().subscribe(info => {
        this.importDate = info?.sysRegDate;
      });
      this.loadList(this.syncParams(data));
    });
  }

  onPageChange(params) {
    this.navigate(this.getParams(params));
  }

  loadList(params?: any) {
    const queryParams = this.getParams(params);
    this.regSrv.getNelegalList(queryParams).subscribe(data => {
      this.entries = data.content;
      this.total = data.totalElements;
      this.scrollRun();
    });
  }

  onSearch() {
    const params = this.getSearchPage(this.filter);
    const queryParams = this.getFilterObject(params);
    queryParams["sort"] = "name";
    queryParams["dir"] = "ASC";
    this.tableService.saveScrollPosition(this.commonKeyStore);
    this.router.navigate(['registries/nelegalInfoAll'], {
      queryParams: {q: Utils.encodeJSONBase64(queryParams)} as Params
    });
  }

  /**
   * метод получения объекта плоского фильтра
   * @param data объект фильтра с полями
   */
  public getFilterObject(data) {
    const filter = this.tableService.getFilterSubject(data);
    return this.getFilterPlanObject(filter);
  }

  /**
   * Проверка по факторам риска
   */
  public checkRiskFactor() {
    this.regSrv.doCheckRiskFactor({id:CheckDictEnum.NELEGAL}, CheckDictEnum.NELEGAL, this.loadCheckList, this.alertObjToCheck);
  }

  ngOnDestroy() {
    this.checkScrollOptions();
  }

  protected readonly CheckDictEnum = CheckDictEnum;
}
